var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "default-page-paddings" }, [
    _c(
      "div",
      { staticClass: "container container-medium" },
      [
        _c("Heading", {
          attrs: {
            title: _vm.$t("faq_title"),
            routeName: "vignette",
            alignment: "text-left",
          },
        }),
        _c(
          "section",
          {
            staticClass:
              "section-intrebari-frecvente d-flex justify-content-center",
          },
          [
            _c("FrequentQuestionComponent", {
              attrs: { homepage: false, faqpage: true },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }